module.exports = __webpack_public_path__ + "img/carbon1.5738b166.png";